import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "20.03.2020r",
    category: "biznes, kryzys marketing internetowy",
    title: "Biznes w czasach pandemii",
    description: (
      <>
        Stało się. Miejsca publiczne zamknięte, kraj objęty kwarantanną, a
        wszyscy pracodawcy, którzy byli w stanie, oddelegowali pracowników do
        pracy zdalnej. Nie każdy jednak może sobie pozwolić na komfort home
        office i brak strachu o spadek zleceń. Większość przedsiębiorców stanęła
        przed ciężkim zadaniem: jak przetrwać na rynku w czasie kryzysu
        epidemiologicznego?
      </>
    ),
    seo:
      "Miejsca publiczne zamknięte, kraj objęty kwarantanną, a wszyscy pracodawcy, którzy byli w stanie, oddelegowali pracowników do pracy zdalnej",
    slug: "/blog/biznes_w_czasach_pandemii",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "",
        text: (
          <>
            Opustoszałe ulice niektórych miast i wsi przypominają kadry z
            apokaliptycznych filmów. Nieliczni ludzie decydują się na
            opuszczenie domów, choć za oknem przecież rozkwita wiosna. Gdzie są
            wszyscy, można by zapytać, ale odpowiedź na to pytanie jest prosta.
            Gdy ludzie nie mogą żyć prawdziwym życiem, <b>żyją w internecie</b>.
            I to samo powinien zrobić każdy przedsiębiorca.
          </>
        ),
      },
      second: {
        title: "Działalność online",
        text: (
          <>
            <b>Biznes w internecie</b> to przede wszystkim otwarcie się na
            możliwości, jakie niesie ze sobą globalna sieć. Jesteśmy
            przyzwyczajeni do zakupów online, czasem może różnych kursów czy
            korepetycji, ale co więcej? Okazuje się, że w obliczu wyzwania wiele
            branż, które teoretycznie mają sens jedynie offline, nagle się w tym
            całym internecie odnajduje. Zumba online czy porady lekarskie przez
            Skype'a to przykłady pierwsze z brzegu. Owszem, wiele zależy od
            tego, gdzie postawimy granicę – jeśli założymy, że tam, gdzie
            wszystko załatwimy przez internet i bez kontaktu z człowiekiem, to
            nawet naprawa samochodu może być online! Wystarczy pomyśleć.
          </>
        ),
      },
      third: {
        title: "",
        text: (
          <>
            Warto również zauważyć, że takie otwarcie się na nowe możliwości
            przyniesie wiele korzyści również po zakończeniu pandemii – to
            <b>inwestycja długoterminowa</b>. Zapotrzebowanie na usługi online
            nagle nie zniknie, gdy ludzie będą mogli wychodzić z domów. Wciąż
            znajdą się klienci chętni do skorzystania z oferty przez internet,
            czy to z własnej wygody, potrzeby czy – po prostu – przyzwyczajeń.
            Jeśli więc prowadzisz zajęcia sportowe – zrób to online! Jesteś
            fryzjerem? Zadbaj o swoich klientów online! – Choćby przy pomocy
            publikacji instruktaży dbania o włosy w czasie niemożności
            skorzystania z Twoich usług czy sprzedażą kosmetyków. Nie zawsze
            droga do tego jest prosta i oczywista, nie wszystkie gałęzie
            gospodarki można całkiem przenieść „do internetu” – ale warto
            zastanowić się nad tym, w jaki sposób może tam zacząć działać Twoja
            branża. Nie masz na to pomysłu? <b>Skontaktuj się z nami</b>.
            Pomożem
          </>
        ),
      },
      fourth: {
        title: "Prowadzenie profili w social mediach",
        text: (
          <>
            Obecność firmy w internecie nie oznacza jedynie przeniesienia tam
            swoich usług. Przede wszystkim, przedsiębiorstwo musi{" "}
            <b>tam istnieć i funkcjonować</b>. Założenie profilu na Facebooku to
            nie jest krok milowy w działalności – to jedynie skierowanie głowy w
            dobrą stronę. Życie ludzi przeniosło się do internetu – ale są to
            wciąż ci sami ludzie, jacy byli przed wybuchem epidemii. Robią więc
            plany, zakupy, szukają inspiracji, edukują się, inspirują.{" "}
            <b>Jeśli nie działają dziś – zadziałają jutro</b> albo potem, jak to
            szaleństwo się już skończy. Nie ma Twoje firmy tam, gdzie ci ludzie
            żyją? Nie będzie jej też potem, gdy staną się klientami.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            Media społecznościowe są szczególnie okrutne pod tym względem.
            Opuszczone profile, choćby nie wiadomo jak wiele miały polubień, w
            końcu <b>znikną i zostaną zapomniane</b> nawet przez swoich
            obserwatorów. Owszem, gdy 1 stycznia 2018 na oficjalnym profilu gry
            Cyberpunk 2077 pojawił się tweet, cały świat zwrócił na niego uwagę,
            a akcje CD Projektu, wydawcy, wystrzeliły w górę – mimo że to była
            pierwsza wiadomość na profilu od 5 lat. Nie każdy przedsiębiorca
            jednak może liczyć na miliony wiernych klientów na całym świecie,
            które tylko czekają na wzmiankę o nowym produkcie – rzeczywistość
            jest bardziej brutalna. Dlatego panuje tutaj zasada:{" "}
            <b>nie publikujesz – nie istniejesz</b>. Prawo dżungli.
          </>
        ),
      },
      sixth: {
        title: "Kampanie wizerunkowe",
        text: (
          <>
            Regularne prowadzenie profili w portalach społecznościowych to
            <b>absolutne minimum</b>, aby móc przetrwać ten trudny czas. Jego
            uzupełnieniem – jeżeli tylko firma może sobie na to pozwolić – jest
            <b>prowadzenie kampanii w social mediach</b>. To stosunkowo tania
            reklama, która przysłuży się jeszcze bardziej niż samo istnienie na
            Facebooku, LinkedInie czy Instagramie. Ktoś mógłby zapytać: na co mi
            reklama w czasie, kiedy mało kto chce kupować?
          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>
            Kampanie w social mediach to nie tylko reklamy sprzedażowe, ale
            bardzo często – a może przede wszystkim –{" "}
            <b>działania wizerunkowe</b>, które mają na celu wzbudzić świadomość
            Twojej marki wśród odbiorców. Katarzynie marzy się nowa kuchnia, ale
            chce przeczekać pandemię – dzięki takiej kampanii za miesiąc może
            zamówić właśnie Twoją. Robert planuje zakup samochodu, ale musiał go
            odłożyć w czasie przez wzgląd na tę niepewną sytuację – może za parę
            tygodni kupi właśnie Twój? Możliwości jest mnóstwo. Bez kampanii ani
            jedna, ani druga sytuacja prawdopodobnie się nie zdarzy, a Katarzyna
            i Robert zrealizują swoje plany – ale u konkurencji.
          </>
        ),
      },
      eigth: {
        title: "Marketing odpowiedzialny społecznie",
        text: (
          <>
            Działania w internecie są ważne bez względu na to, czy popyt na
            usługi firmy w czasie epidemii wciąż istnieje, czy jednak zanika.
            Istnieją branże, które – po prostu – wymagają kontaktu face to face,
            takie jak hotelowa, kosmetyczna czy ślubna. Takie firmy – czy chcą,
            czy nie – muszą przerwać podstawową działalność. Remedium to nie
            tylko{" "}
            <b>aktywne prowadzenie profili czy kampanii w social mediach</b> –
            to również dobry moment na{" "}
            <b>marketing odpowiedzialny społecznie</b>. Bardzo dobrze
            wykorzystuje go aktualnie branża gastronomiczna w akcji
            #gastropomaga, gdzie restauracje dostarczają nieodpłatnie posiłki
            dla personelu medycznego w szpitalach. Mniej znane przykłady
            obejmują firmy zajmujące się naprawą samochodów, które za darmo
            dezynfekują pojazdy policyjne czy karetki, zakłady kosmetyczne,
            które dzielą się swoimi zapasami środków dezynfekujących czy
            jednorazowych środków ochrony, a także szwalnie, które szyją
            maseczki dla potrzebujących.
          </>
        ),
      },
      ninth: {
        title: "",
        text: (
          <>
            Takie akcje odbijają się szerokim echem w społeczeństwie. W
            większości niosą ze sobą <b>pozytywny feedback</b>, choć zdarzają
            się malkontenci wskazujący, że to tylko marketing. Ale to nie byle
            jaki marketing. To marketing, który niesie ze sobą niesamowitą
            wartość i w tych trudnych czasach może stanowić ratunek dla
            przedsiębiorstwa – bez względu na to, czy wynika ze szlachetnych
            pobudek, czy nie.
          </>
        ),
      },
      tenth: {
        title: "Bezpieczeństwo pracowników i klientów",
        text: (
          <>
            Istnieją jednak firmy, które nie mogą ograniczyć swoich działań,
            pomimo tego, że ich branża wymaga kontaktu z klientem twarzą w
            twarz. Ważna jest wtedy dbałość o bezpieczeństwo nie tylko klientów,
            ale również pracowników. Maseczki, płyny dezynfekujące, rękawiczki,
            maksymalne ograniczenie kontaktu face to face, a także wprowadzenie
            możliwości płatności bezgotówkowych: to wszystko buduje Twój
            wizerunek jako partnera godnego zaufania, nawet w trudnym czasie.
          </>
        ),
      },
      eleventh: {
        title: (
          <>
            Potrzebujesz pomocy? <b>Skontaktuj się!</b>{" "}
          </>
        ),
        text: (
          <>
            Wszystkie powyższe działania na pewno pomogą firmom przetrwać ten
            trudny czas. Nawet, jeśli nie wszystkie mogą przynieść korzyści
            teraz – nie zapominajmy, że za parę dni, tygodni, czy miesięcy,
            epidemia się skończy. Wtedy się okaże, jak rozsądne były podjęte
            działania.
          </>
        ),
      },
      twelfth: {
        title: "",
        text: (
          <>
            Jeśli jesteś przedsiębiorcą i nie wiesz, jak sobie poradzić,{" "}
            <b>napisz do nas</b>, pomożemy. W końcu jesteśmy agencją o
            kosmicznych możliwościach. :)
          </>
        ),
      },
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
    },
  };
};
